import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  Divider,
} from '@mui/material';
import { useViewport } from '../hooks/useViewport';

interface ItemViewModalProps {
  open: boolean;
  onClose: () => void;
  icon: React.ReactElement<Record<string, unknown>>;
  title: string;
  color: 'primary' | 'secondary';
  rank: number;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

const ItemViewModal: React.FC<ItemViewModalProps> = ({
  open,
  onClose,
  icon,
  title,
  color,
  rank,
  children,
  actions,
}) => {
  // A phone has no room for a centred dialog's margins, so the detail takes the whole screen.
  const { isPhone } = useViewport();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isPhone}
      PaperProps={{
        sx: isPhone ? undefined : { maxHeight: '80vh' }
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        {React.cloneElement(icon, { color })}
        <Typography variant="h6" component="span">
          {title}
        </Typography>
        <Box sx={{ ml: 'auto' }}>
          <Chip
            label={`Rank #${rank}`}
            size="small"
            color={color}
            variant="outlined"
          />
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2 }}>
        {children}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        {actions}
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItemViewModal;
